import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import AsyncSelect from "react-select/async";
import { Input } from "@mantine/core";

const RHFAsyncFlightSelect = ({
  name,
  label,
  rules,
  defaultOptions,
  loadOptions,
  withAsterisk,
  placeholder = "Choose...",
  onChangeCallback, // Optional callback for extra side-effects
  ...props
}) => {
  const { control } = useFormContext();

   const selectStyles = {
    control: (base) => ({
      ...base,
      background: "#e8eef7 !important",
      outline: "none !important",
      border: "none !important",
       boxShadow: "none !important",
       padding: '8px !important',
      borderRadius:'26px !important',
      // width: "280px",
      // maxWidth: "280px",
      // minWidth: "280px",

      width: "100%",
      maxWidth: "100%",
      minWidth: "100%",
    }),
    menu: (base) => ({
      ...base,
      background: "#ffffff",
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      background: isSelected
        ? "#007bff"
        : isFocused
          ? "#f0f0f0"
          : "transparent",
      color: isSelected ? "#ffffff" : "#000000",
    }),
    singleValue: (base, { isDisabled }) => ({
      ...base,
      color: isDisabled ? "#222" : "#222",
      opacity: 1,
    }),
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => {
        
        // react-select requires an object { label, value }.
        // If your form state stores a plain string (like "Indigo"), we format it for react-select here.
        const selectValue = value
          ? typeof value === "object"
            ? value
            : { label: value, value: value } // Map primitive to object
          : null;

        return (
          <Input.Wrapper
            label={label}
            withAsterisk={withAsterisk}
            error={error?.message}
             styles={{
              label: {
              fontSize: "16px",lineHeight: "24px",fontWeight: 400,color: "#222222",marginBottom:'8px'
            }}}
          >
            <AsyncSelect
              ref={ref}
              cacheOptions={false}
              defaultOptions={defaultOptions}
              loadOptions={loadOptions}
              placeholder={placeholder}
              styles={selectStyles}
              
              value={selectValue}
              onBlur={onBlur}
              onChange={(selectedOption) => {
                // By default, save just the primitive value to React Hook Form state
                // If you need the whole object saved, change this to: onChange(selectedOption)
                //   onChange(selectedOption ? selectedOption.value : null);
                  onChange(selectedOption ? selectedOption.label : null);

                // Run any additional logic you passed in (like setting custom states)
                if (onChangeCallback) {
                  onChangeCallback(selectedOption);
                }
              }}
              // Minimal styling adjustments so react-select feels more like Mantine
             
              {...props}
            />
          </Input.Wrapper>
        );
      }}
    />
  );
};

export default RHFAsyncFlightSelect;